export const tr = {
    'error-refresh': 'Hata oluştu. Lütfen, sayfayı yenilemeyi deneyin.'
};
